// @flow

// eslint-disable-next-line import/prefer-default-export
export const UPDATE_BREADCRUMBS = 'update:breadcrumbs';
